import React from "react";
import styles from "./style.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
function AboutUs() {
  const { getAboutUs } = useSelector((state) => state.aboutUs);
  console.log("aboutUs::", getAboutUs);
  return (
    <div className={styles.data}>
      <h1>About Fanzpick</h1>
      {/* <p>
        Welcome to Fanzpick, the ultimate app for passionate sports fans like
        you! Our platform is designed to bring fans together, empowering you to
        voice your opinions, showcase your tactical prowess, and engage in
        lively discussions with fellow supporters.
      </p>
      <p>
        <b>Our Mission:</b>
      </p>
      <p>
        At Fanzpick, our mission is to create a vibrant community where fans
        from all over the world can unite and express their unwavering love for
        their favorite teams. We believe that fans are the heart and soul of
        sports, and your opinions matter. Our app serves as a digital hub for
        aggregating fan sentiments, providing you with a unique space to have
        your say on your team's lineup and in-game decisions.
      </p>
      <p>
        <b>How it Works:</b>
      </p>
      <p>
        Using Fanzpick is easy and enjoyable. During live games, you get to act
        as a virtual manager, creating your ideal starting lineup and suggesting
        tactical changes in real-time. Your choices are then combined with the
        inputs of other fans supporting the same team. We present these
        collective opinions in compelling statistics, giving you insights into
        how your views align with those of your fellow fans and the actual
        managerial decisions.
      </p>
      <p>
        <b>Stay True to Your Team:</b>
      </p>
      <p>
        Fanzpick celebrates the essence of fandom by encouraging loyalty to your
        favorite team. We understand that being a true supporter means
        dedicating your passion to one team, and that's why we focus on
        delivering an unparalleled experience for your chosen club.
      </p>
      <p>
        <b>Sharing the Love:</b>
      </p>
      <p>
        Your passion for your team doesn't have to be kept to yourself. With
        Fanzpick, you can easily share your lineup selections and tactical
        choices with friends and fellow fans across major social media
        platforms. Spread the excitement, spark discussions, and connect with
        like-minded supporters who share your dedication and enthusiasm.
      </p>
      <p>
        <b>Recognising Performances:</b>
      </p>
      <p>
        In Fanzpick, we've included special icons to help you express your
        thoughts on player performances. Use the hairdryer icon to voice your
        disapproval towards a player's underwhelming performance, and award the
        star icon to acknowledge the outstanding efforts of a player who shines
        on the field.
      </p>
      <p>
        <b>Feedback and Support:</b>
      </p>
      <p>
        We value your feedback, and your satisfaction is our top priority. If
        you encounter any issues, have suggestions for improvements, or notice
        any missing data, please don't hesitate to reach out to our support team
        at mailto:support@fanzpick.com. We are committed to continuously
        enhancing the Fanzpick experience based on your input.
      </p>
      <p>
        Join us on this exhilarating journey as we celebrate the heart of sports
        - the fans! Download Fanzpick now and immerse yourself in a world of
        spirited opinions, tactical insights, and the joy of supporting your
        beloved team like never before. Let's make every match an unforgettable
        experience together!
      </p> */}

      <div dangerouslySetInnerHTML={{ __html: getAboutUs?.data?.content }} />
    </div>
  );
}

export default AboutUs;
